import React from "react"

import * as styles from "./index.module.scss"
import { Background } from "@/components"

interface IProps {
  title: string | React.ReactNode
  subtitle: string
  image: {
    media: BackgroundImg
  }
}

const AboutUsBanner: React.FC<IProps> = ({ title, subtitle, image }) => {
  return (
    <Background className={styles.banner} image={image}>
      <div className={styles.container}>
        <h1>{title}</h1>
        <h2>{subtitle}</h2>
      </div>
    </Background>
  )
}

export default AboutUsBanner
